import React, { useState, useEffect } from 'react';
/* global axios */
import api from '../services/apiService';
import { Helmet } from 'react-helmet';

const PermissionForm = () => {
  const [permissions, setPermissions] = useState([]);
  const [loading, setLoading] = useState(true);

  const [newName, setNewName] = useState('');
  const [newDescription, setNewDescription] = useState('');

  const [editingId, setEditingId] = useState(null);
  const [editedName, setEditedName] = useState('');
  const [editedDescription, setEditedDescription] = useState('');

  const fetchPermissions = async () => {
    try {
      const response = await api.get('/permissions');
      setPermissions(response.data);
    } catch (error) {
      console.error('Fehler beim Laden der Permissions:', error);
      alert('Fehler beim Laden der Permissions');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPermissions();
  }, []);

  const handleAdd = async () => {
    if (!newName) {
      alert('Bitte einen Namen eingeben!');
      return;
    }
    try {
      await api.post('/permissions', { name: newName, description: newDescription || null });
      setNewName('');
      setNewDescription('');
      fetchPermissions();
    } catch (error) {
      console.error('Fehler beim Hinzufügen der Permission:', error);
      alert('Fehler beim Hinzufügen der Permission');
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Permission wirklich löschen?')) return;
    try {
      await api.delete(`/permissions/${id}`);
      setPermissions(permissions.filter(p => p.id !== id));
      alert('Permission gelöscht');
    } catch (error) {
      console.error('Fehler beim Löschen der Permission:', error);
      alert('Fehler beim Löschen der Permission');
    }
  };

  const handleEdit = (perm) => {
    setEditingId(perm.id);
    setEditedName(perm.name);
    setEditedDescription(perm.description || '');
  };

  const handleCancel = () => {
    setEditingId(null);
    setEditedName('');
    setEditedDescription('');
  };

  const handleUpdate = async (id) => {
    if (!editedName) {
      alert('Name darf nicht leer sein!');
      return;
    }
    try {
      await api.put(`/permissions/${id}`, { name: editedName, description: editedDescription || null });
      setEditingId(null);
      fetchPermissions();
    } catch (error) {
      console.error('Fehler beim Aktualisieren der Permission:', error);
      alert('Fehler beim Aktualisieren der Permission');
    }
  };

  if (loading) {
    return <div>Daten werden geladen...</div>;
  }

  return (
    <div style={{ display: 'flex', justifyContent: 'center', padding: '20px' }}>
      <div style={{ width: '800px' }}>
        <Helmet>
          <title>Permissions verwalten</title>
          <meta name="description" content="Permissions verwalten" />
        </Helmet>

        <h2 style={{ textAlign: 'center', marginBottom: '20px' }}>Permissions verwalten</h2>

        {/* Hinzufügen-Formular */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: '2fr 3fr auto',
          gap: '10px',
          marginBottom: '20px',
          alignItems: 'center'
        }}>
          <input
            type="text"
            value={newName}
            onChange={e => setNewName(e.target.value)}
            placeholder="Name"
            style={{ padding: '5px', borderRadius: '4px', border: '1px solid #ccc' }}
          />
          <input
            type="text"
            value={newDescription}
            onChange={e => setNewDescription(e.target.value)}
            placeholder="Beschreibung"
            style={{ padding: '5px', borderRadius: '4px', border: '1px solid #ccc' }}
          />
          <button
            onClick={handleAdd}
            style={{
              padding: '6px 12px',
              background: '#28a745',
              color: '#fff',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer'
            }}
          >
            Hinzufügen
          </button>
        </div>

        {/* Listenansicht */}
        <ul style={{ listStyle: 'none', padding: 0 }}>
          {permissions.map(perm => (
            <li key={perm.id} style={{
              display: 'grid',
              gridTemplateColumns: '2fr 3fr auto',
              gap: '10px',
              alignItems: 'center',
              padding: '8px 0',
              borderBottom: '1px solid #ddd'
            }}>
              {editingId === perm.id ? (
                <>
                  <input
                    type="text"
                    value={editedName}
                    onChange={e => setEditedName(e.target.value)}
                    style={{ padding: '5px', borderRadius: '4px', border: '1px solid #ccc' }}
                  />
                  <input
                    type="text"
                    value={editedDescription}
                    onChange={e => setEditedDescription(e.target.value)}
                    style={{ padding: '5px', borderRadius: '4px', border: '1px solid #ccc' }}
                  />
                  <div>
                    <button onClick={() => handleUpdate(perm.id)} style={{ marginRight: '5px' }}>✅</button>
                    <button onClick={handleCancel}>✖️</button>
                  </div>
                </>
              ) : (
                <>
                  <span>{perm.name}</span>
                  <span>{perm.description}</span>
                  <div>
                    <button onClick={() => handleEdit(perm)} style={{
                      fontSize: '15px',
                      padding: '5px 10px',
                      background: '#007bff',
                      color: '#fff',
                      border: 'none',
                      borderRadius: '5px',
                      cursor: 'pointer',
                      marginRight: '5px'
                    }}>
                      Bearbeiten
                    </button>
                    <button onClick={() => handleDelete(perm.id)} style={{
                      fontSize: '15px',
                      padding: '5px 10px',
                      background: '#dc3545',
                      color: '#fff',
                      border: 'none',
                      borderRadius: '5px',
                      cursor: 'pointer'
                    }}>
                      Löschen
                    </button>
                  </div>
                </>
              )}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default PermissionForm;
